// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__huBRH","title":"Info_title__kqm_Q","selects":"Info_selects__5Y_1y","requiredAsterisk":"Info_requiredAsterisk__Qth-f"};